import styled, { createGlobalStyle } from 'styled-components';

export const ThemeStyle = createGlobalStyle`
  body {
    font-family: ${({ font }) => font.body_font}, 'Helvetica', sans-serif;
    color: ${({ colors }) => colors[5].color}
  }

  h1, h2, label {
    font-family: ${({ font }) => font.header_font}, Helvetica, Sans-Serif;
  }

  h3, h4, h5 {
    font-family: ${({ font }) => font.body_font}, Helvetica, Sans-Serif;
  }

  input, textarea, select {
    color: ${({ colors }) => colors[5].color};
  }

  button, input, textarea {
    outline-color: ${({ colors }) => colors[7].color}
  }

  .hoverable {
    &:hover, &:focus, &:active {
      position: relative;
      &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0.1;
        background-color: ${({ colors }) => colors[7].color};
        border-radius: inherit;
      }
    }
  }
`;

const color = '#EBF2F4';

export const Loading = styled.div`
  display: flex;
  padding: 48px 0;
  align-items: center;
  justify-content: center;
  height: 480px;

  .loader,
  .loader:before,
  .loader:after {
    background: ${color};
    -webkit-animation: load1 1s infinite ease-in-out;
    animation: load1 1s infinite ease-in-out;
    width: 1em;
    height: 4em;
  }
  .loader {
    color: ${color};
    text-indent: -9999em;
    margin: 88px auto;
    position: relative;
    font-size: 11px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }
  .loader:before,
  .loader:after {
    position: absolute;
    top: 0;
    content: '';
  }
  .loader:before {
    left: -1.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }
  .loader:after {
    left: 1.5em;
  }
  @-webkit-keyframes load1 {
    0%,
    80%,
    100% {
      box-shadow: 0 0;
      height: 4em;
    }
    40% {
      box-shadow: 0 -2em;
      height: 5em;
    }
  }
  @keyframes load1 {
    0%,
    80%,
    100% {
      box-shadow: 0 0;
      height: 4em;
    }
    40% {
      box-shadow: 0 -2em;
      height: 5em;
    }
  }
`;
